<template>
  <div :id="name">
    <div class="action-part">
      <el-form :inline="true" size="medium">
        <el-form-item>
          <el-button type="primary" @click="showEditor(null)">上传故事</el-button>
        </el-form-item>
        <el-form-item>
          <el-select v-model="search.categoryId" placeholder="请选择故事分类">
            <el-option :label="item.name" :value="item.id" v-for="item in categoryList"
                       :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入故事名称" v-model="search.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doSearch">查 询</el-button>
          <el-button type="info" @click="doSearchCancel">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-list">
      <el-table
          border
          :data="resultList"
          style="width: 100%">
        <el-table-column
            prop="title"
            label="故事名称">
        </el-table-column>
        <el-table-column
            prop="ord"
            label="排序"
            align="center">
        </el-table-column>
        <el-table-column
            label="所属分类">
          <template slot-scope="scope">
            <span style="cursor: pointer;color: #4E7BD3" @click="searchCategory(scope.row.categoryId)">{{ scope.row.categoryName }}</span>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="上架/下架">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.enable" active-value="1" inactive-value="0"
                       @change="onItemEnableChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column
            prop="playCount"
            align="center"
            label="播放量">
        </el-table-column>
        <el-table-column
            prop="duration"
            align="center"
            label="时长(秒)">
        </el-table-column>
        <el-table-column
            prop="mp3Name"
            label="文件名称">
        </el-table-column>
        <el-table-column
            label="文件大小">
          <template slot-scope="scope">
            <span>{{ getMemorySize(scope.row.mp3Size) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="createTime"
            label="创建时间">
        </el-table-column>
        <el-table-column
            align="center"
            width="300"
            label="操作">
          <template slot-scope="scope">
            <el-button type="info" size="medium" @click="doItemPlay(scope.row)">播放</el-button>
            <el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='马上删除'
                cancel-button-text='我后悔了'
                icon="el-icon-info"
                @confirm="deleteItem(scope.row)"
                icon-color="red"
                title="确定删除该故事吗？">
              <el-button slot="reference" type="danger" style="margin-left: 10px;" size="medium">
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-part">
      <el-pagination
          size="small"
          background
          @current-change="loadByPage"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          layout="prev, pager, next"
          :total="pagination.total">
      </el-pagination>
    </div>
    <div class="dialog-part">
      <el-dialog
          width="400px"
          :title="dialogText"
          :visible.sync="isEditorShow"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          center>
        <div class="dialog-content">
          <el-form :inline="true" size="medium">
<!--            <el-form-item label="模块" :required="true">-->
<!--              <el-cascader-->
<!--                  clearable-->
<!--                  v-model="selectModuleIds"-->
<!--                  :options="appModuleTreeData"-->
<!--                  :props="{ checkStrictly: true, value: 'id', label: 'name' }"-->
<!--                  :show-all-levels="true"-->
<!--                  @change="() => {}" placeholder="请选择数据的模块"></el-cascader>-->
<!--            </el-form-item>-->
            <el-form-item label="音频文件" :required="true">
              <el-upload
                  ref="importUpload"
                  :auto-upload="true"
                  name="mp3"
                  :file-list="uploadFile"
                  :timeout="300000"
                  :on-change="onFileChange"
                  :on-success="onUploadSuccess"
                  :with-credentials="true"
                  accept=".mp3"
                  :action="mp3UploadPath"
                  :limit="1">
                <el-button size="small" type="primary">{{ uploadText }}</el-button>
                <div slot="tip" class="el-upload__tip">只能上传.mp3文件，且不超过10M</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="故事名称" :required="true">
              <el-input placeholder="请输入故事名称" v-model="story.title"></el-input>
            </el-form-item>
            <el-form-item label="所属分类" :required="true">
              <el-select v-model="story.categoryId" placeholder="请选择故事分类">
                <el-option :label="item.name" :value="item.id" v-for="item in categoryList"
                           :key="item.id"></el-option>
              </el-select>
            </el-form-item>
<!--            <el-form-item label="石头" :required="true">-->
<!--              <el-select v-model="story.payWith">-->
<!--                <el-option value="0" label="免费"></el-option>-->
<!--                <el-option value="1" label="绿色石头"></el-option>-->
<!--                <el-option value="2" label="蓝色石头"></el-option>-->
<!--                <el-option value="3" label="红色石头"></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="单价" :required="true" v-if="story.payWith!==null&&story.payWith!=='0'">-->
<!--              <el-input-number v-model="story.price" :min="1"></el-input-number>-->
<!--            </el-form-item>-->
            <el-form-item label="列表排序" :required="true">
              <el-input-number v-model="story.ord" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="是否上架" :required="true">
              <el-switch v-model="story.enable" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
                   <el-button @click="onEditorCancel" size="medium">取 消</el-button>
                   <el-button type="primary" @click="onEditorConfirm" size="medium">提 交</el-button>
                </span>
      </el-dialog>
      <audio :src="targetPlayUrl" id="audio"></audio>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'

export default {
  data() {
    return {
      name: 'dev-product',
      pagination: {
        pageSize: 1,
        total: 0,
        currentPage: 1,
        totalPage: 1
      },
      search: {
        categoryId: '',
        name: ''
      },
      categoryList: [],
      dialogText: '',
      selectModuleIds: [],
      appModuleTreeData: [],
      story: {
        id: '',
        title: '',
        enable: '1',
        mp3Id: '',
        categoryId: '',
        moduleId: '',
        payWith: '0',
        price: 0,
        ord: 0
      },
      isEditorShow: false,
      uploadFile: [],
      mp3UploadPath: '',
      resultList: [],
      uploadText: '',
      targetPlayUrl: ''
    }
  },
  methods: {
    getModuleTreeData() {
      api.getAppModuleTree().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.appModuleTreeData = result.data;
        }
      })
    },
    doItemPlay(item) {
      let mp3Id = item.mp3Id;
      //去获取令牌
      api.getMp3PlayToken(mp3Id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.targetPlayUrl = result.data.url;
          let audio = document.getElementById('audio');
          if (audio) {
            this.$nextTick(function () {
              audio.play();
            });
          }
        } else {
          this.$message.error(result.msg)
        }
      });
    },
    onItemEnableChange(item) {
      api.putStory(item).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success("更新状态成功.")
        } else {
          this.$message.error("更新状态失败.")
        }
      })
    },
    deleteItem(item) {
      let id = item.id;
      api.deleteStory(id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.listContent();
          this.$message.success(result.msg);
        } else {
          this.$message.error(result.msg);
        }
      })
    },
    searchCategory(categoryId) {
      this.search.categoryId = categoryId;
      this.doSearch();
    },
    getMemorySize(size) {
      if (!size)
        return "";
      let num = 1024.00; //byte
      if (size < num)
        return size + " Byte";
      if (size < Math.pow(num, 2))
        return (size / num).toFixed(2) + " KB"; //kb
      if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + " MB"; //M
      if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + " GB"; //G
      return (size / Math.pow(num, 4)).toFixed(2) + " TB"; //T
    },
    onFileChange(file) {
      if (this.story.title === '') {
        this.story.title = file.name.replaceAll(".mp3", "");
      }
    },
    onUploadSuccess(result) {
      if (result.code === api.SUCCESS_CODE) {
        this.$message.success(result.msg);
        this.story.mp3Id = result.data;
      } else {
        this.$message.error(result.msg);
      }
    },
    doSearch() {
      this.pagination.currentPage = 1;
      this.listContent();
    },
    onEditorConfirm() {
      this.story.moduleId = this.selectModuleIds[this.selectModuleIds.length - 1];
      if (this.story.title === '') {
        return this.$message.error("请填写故事标题.");
      }
      if (this.story.categoryId === '') {
        return this.$message.error("请选择故事所属分类.");
      }
      if (this.story.mp3Id === '') {
        return this.$message.error("请上传音频文件.")
      }
      if (this.story.id === '') {
        api.postStory(this.story).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$message.success(result.msg);
            this.listContent();
            this.onEditorCancel();
          } else {
            this.$message.error(result.msg);
          }
        })
      } else {
        api.putStory(this.story).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$message.success(result.msg);
            this.listContent();
            this.onEditorCancel();
          } else {
            this.$message.error(result.msg);
          }
        })
      }
    },
    onEditorCancel() {
      this.isEditorShow = false;
      this.story.mp3Id = '';
      this.story.id = '';
      this.story.title = '';
      this.story.categoryId = '';
      this.story.enable = '1';
      this.story.ord = 0;
      this.story.price = 0;
      this.story.payWith = '0';
      this.story.moduleId = '0';
    },
    showEditor(item) {
      this.selectModuleIds = [];
      this.uploadFile = []
      this.onEditorCancel()
      if (item) {
        this.dialogText = '编辑故事';
        this.uploadText = '覆盖原文件';
        this.story.id = item.id;
        this.story.title = item.title;
        this.story.enable = item.enable;
        this.story.categoryId = item.categoryId;
        this.story.ord = item.ord;
        this.story.mp3Id = item.mp3Id;
        this.story.price = item.price;
        this.story.payWith = item.payWith;
        this.story.moduleId = item.moduleId;
        this.selectModuleIds.push(item.moduleId)
      } else {
        this.uploadText = '选择文件';
        this.dialogText = '创建故事';
      }
      this.isEditorShow = true;
    },
    doSearchCancel() {
      this.search.categoryId = '';
      this.search.name = '';
      this.doSearch();
    },
    loadByPage(page) {
      this.pagination.currentPage = page;
      this.listContent();
    },
    listContent() {
      api.listStories(this.pagination.currentPage, this.search).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          let data = result.data;
          this.resultList = data.list;
          this.pagination.currentPage = data.currentPage;
          this.pagination.pageSize = data.pageSize;
          this.pagination.total = data.total;
          this.pagination.totalPage = data.totalPage;
        }
      })
    },
    listCategories() {
      api.listStoryCategories().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.categoryList = result.data;
        }
      })
    }
  },
  mounted() {
    // 处理mp3上传地址，拼接上token信息
    const token = this.$store.state.user.token;
    this.mp3UploadPath = api.baseUrl + `/md/mp3?ct-sob-admin-token=${token}`

    let categoryId = this.$route.query.categoryId;
    if (categoryId) {
      this.search.categoryId = categoryId;
    }
    this.listContent();
    this.listCategories();
    this.getModuleTreeData();
  }
}
</script>
<style>

.content-list {
  margin-bottom: 20px;
}
</style>
